import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "./SignIn.module.sass";
import { Link } from "react-router-dom";
import TextInput from "../../components/TextInput";
import Image from "../../components/Image";
import { useUser } from "../../context";
import Cookie from "universal-cookie";
import { AuthLogin } from "../../auth";
import { LoginWithMFA } from "./loginWithMFA";
import Loader from "../../components/Loader";
import Code from "../SignUp/Code";
import { UseApi } from "../../hooks/use-api";
import { ResendConfirmation } from "../../Services/lib/auth";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import auth from "../../i11/auth";
import AppVersion from "../../components/Version";

const SignIn = () => {
	const [username, setOnchangeUsername] = useState("");
	const [password, setOnchangePassword] = useState("");
	const [{ data }, fetch] = UseApi({
		service: ResendConfirmation,
	});
	const [loading, setLoading] = useState(false);
	const [MFA, setMFA] = useState(false);
	const [Session, setSession] = useState("");
	const [userSRP, setUserSRP] = useState("");
	const [verifyData, setVerifyData] = useState({
		username: "",
		confirmationCode: "",
	});
	const [isOpen, setOpen] = useState(false);
	const [passwordShown, setPasswordType] = useState("password");
	const togglePassword = () => {
		if (passwordShown === "password") {
			setPasswordType("text");
			return;
		}
		setPasswordType("password");
	};
	const { locale, setLogged, setTokens, setUsername, interval, setbrand } =
		useUser();
	const onSubmit = (e) => {
		e.preventDefault();

		AuthLogin(
			{ username: username.trim(), password: password.trim() },
			Cookie,
			interval,
			setLogged,
			setTokens,
			setLoading,
			setUsername,
			setMFA,
			setSession,
			setUserSRP,
			setVerifyData,
			setOpen,
			setbrand
		);
	};
	useEffect(() => {
		if (isOpen) {
			fetch(username);
		}
	}, [isOpen]);
	useEffect(() => {
		if (data) {
			ToastEmitter({
				msg: `Confirmation code sent to your ${data.CodeDeliveryDetails.Destination}. Please check your ${data.CodeDeliveryDetails.AttributeName}`,
				type: "success",
			});
		}
	}, [data]);
	return (
		<div className={styles.login} style={{ minHeight: "100vh" }}>
			{isOpen ? (
				<div className={styles.wrapper}>
					<Code verifyData={verifyData} setVerifyData={setVerifyData} />
				</div>
			) : (
				<div className={styles.wrapper}>
					<Link className={styles.logo} to="/">
						<Image
							className={styles.pic}
							src="/images/logo-dark.png"
							srcDark="/images/logo-light.png"
							alt="Core"
						/>
					</Link>
					<div className={cn("h2", styles.title)}>{auth[locale].sign_in}</div>
					<div className={styles.body}>
						<form onSubmit={onSubmit}>
							<TextInput
								className={styles.field}
								name="text"
								type="username"
								placeholder={auth[locale].enter_email}
								required
								icon="mail"
								onChangeInput={setOnchangeUsername}
							/>
							<TextInput
								className={styles.field}
								name="password"
								type={passwordShown === "text" ? "text" : "password"}
								placeholder={auth[locale].password}
								required
								icon="lock"
								onChangeInput={setOnchangePassword}
								togglePassword={togglePassword}
								passwordType={passwordShown}
							/>
							<button
								className={cn(
									`button ${loading ? "disabled" : ""}`,
									styles.button
								)}
								type="submit"
							>
								{loading ? (
									<Loader white />
								) : (
									<span>{auth[locale].sign_in}</span>
								)}
							</button>
						</form>
						<div className={styles.note}>{auth[locale].disclaimer}</div>
						<div className={styles.info}>
							{auth[locale].forget_pass}
							{"  "}
							<Link className={styles.link} to="/reset-password">
								{auth[locale].reset}
							</Link>
						</div>
					</div>
				</div>
			)}
			{MFA && (
				<LoginWithMFA
					isOpen={MFA}
					onClose={() => {
						setMFA(false);
					}}
					body={{ username: userSRP, Session }}
					setVerifyData={setVerifyData}
					setOpen={setOpen}
				/>
			)}
			<AppVersion />
		</div>
	);
};

export default SignIn;
